<template>
  <div>
    <b-row class="mb-2">
      <b-col class="text-right">
        <b-button variant="primary" size="sm" @click="openAddVehicle">
          <feather-icon icon="PlusIcon" class="mr-50" />
          Adicionar Veículo à Viagem
        </b-button>
      </b-col>
    </b-row>

    <!-- Lista de Veículos do Evento -->
    <b-table :items="veiculosEvento" :fields="fields" responsive primary-key="id" show-empty empty-text="Nenhum veículo alocado para este evento.">
      <template #cell(veiculo)="data">
        {{ data.value.descricao }} ({{ data.value.placa }})
      </template>
      <template #cell(acoes)="data">
        <b-button variant="info" size="sm" class="mr-50" @click="verMapa(data.item)">
          <feather-icon icon="MapIcon" />
          Mapa de Assentos
        </b-button>
        <b-button variant="danger" size="sm" @click="removerVeiculo(data.item.id)">
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>

    <!-- Modal Mapa de Assentos -->
    <b-modal id="modal-mapa" title="Mapeamento de Assentos" size="lg" hide-footer>
      <div v-if="selectedVeiculo" class="text-center">
        <h5>{{ selectedVeiculo.veiculo.descricao }} - {{ selectedVeiculo.veiculo.placa }}</h5>
        
        <!-- Seletor de Andar se for Double Decker -->
        <b-button-group size="sm" class="mb-2" v-if="hasAndares">
          <b-button v-for="a in andares" :key="a" :variant="currentAndar === a ? 'primary' : 'outline-primary'" @click="currentAndar = a">
            {{ a }}º Andar
          </b-button>
        </b-button-group>

        <!-- Grade de Assentos -->
        <div class="seat-grid d-flex flex-wrap justify-content-center p-2 border rounded bg-light">
          <div v-for="n in selectedVeiculo.veiculo.qtoLugares" :key="n" 
               class="seat-box m-25 p-50 border rounded text-center cursor-pointer"
               :class="getSeatClass(n)"
               @click="manageSeat(n)">
            <small class="d-block">#{{ n }}</small>
            <feather-icon :icon="isOccupied(n) ? 'UserCheckIcon' : 'UserIcon'" size="14" />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BRow, BCol, BButton, BTable, BModal, BButtonGroup } from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BButton, BTable, BModal, BButtonGroup },
  props: ['eventoId'],
  data() {
    return {
      veiculosEvento: [],
      selectedVeiculo: null,
      currentAndar: 1,
      fields: [
        { key: 'veiculo', label: 'Veículo' },
        { key: 'motorista', label: 'Motorista' },
        { key: 'veiculo.qtoLugares', label: 'Capacidade' },
        { key: 'acoes', label: 'Ações' }
      ]
    }
  },
  computed: {
    hasAndares() {
      // Lógica para detectar se o veículo tem 2 andares
      return true // placeholder
    },
    andares() {
      return [1, 2]
    }
  },
  methods: {
    verMapa(item) {
      this.selectedVeiculo = item
      this.$bvModal.show('modal-mapa')
    },
    getSeatClass(n) {
      return this.isOccupied(n) ? 'bg-success text-white' : 'bg-white text-primary'
    },
    isOccupied(n) {
      // Verificar se assento n está na lista de VeiculoAssento ocupados
      return false
    },
    manageSeat(n) {
      // Lógica para abrir seletor de participante para o assento n
    },
    openAddVehicle() {
      // Modal para escolher veículo da frota geral
    }
  }
}
</script>

<style scoped>
.seat-box {
  width: 50px;
  height: 50px;
  transition: all 0.2s;
}
.seat-box:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>
